<form [formGroup]="pipNonDigi">
  <axis-card>
    <axis-card-body>
      <h1 class="axis-h3">{{ nonDigital?.title }}</h1>
      <div
        class="axis-form-group"
        [ngClass]="{
          'has-axis-error':
            pipNonDigi.get('piprejectDigiSelect')?.invalid && pipNonDigi.get('piprejectDigiSelect').touched,
        }"
        [ngClass]="{ 'has-axis-required': selectedOption === '' }"
      >
        <label class="axis-control-label">{{ nonDigital?.label }}</label>
        <axis-radio-button-wrapper formControlName="piprejectDigiSelect">
          @for (option of nonDigital?.radioOptions; track option) {
            <axis-radio
              [heading]="option.label"
              [value]="option.value"
              name="mailOptions"
              (changeDetect)="onOptionChange(option.value)"
            >
            </axis-radio>
          }
        </axis-radio-button-wrapper>
        @if (pipNonDigi.get("piprejectDigiSelect").invalid && pipNonDigi.get("piprejectDigiSelect").touched) {
          <div class="axis-error-block">Please select an Option.</div>
        }
      </div>
      @if (selectedOption === "mail") {
        <axis-card>
          <axis-card-body>
            <h2 class="axis-h4">{{ nonDigital?.addressForm?.formHeading }}</h2>
            <p>{{ nonDigital?.addressForm?.note }}</p>

            <div class="axis-grid axis-form-row">
              <div class="axis-col-md-6">
                <div
                  class="axis-form-group has-axis-required"
                  [ngClass]="{
                    'has-axis-error':
                      pipNonDigi.get('piprejInsuredName').value === '' && pipNonDigi.get('piprejInsuredName').touched,
                  }"
                  [ngClass]="{ 'has-axis-required': pipNonDigi.get('piprejInsuredName').value === '' }"
                >
                  <label
                    class="axis-control-label"
                    for="insuredName"
                    >Insured’s Name
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    [attr.aria-describedby]="
                      pipNonDigi.get('piprejInsuredName').value === '' ? 'insuredNameError' : null
                    "
                    type="text"
                    class="axis-form-control"
                    id="insuredName"
                    formControlName="piprejInsuredName"
                  />
                  <div
                    class="axis-error-block"
                    id="insuredNameError"
                  >
                    Please enter Insured Name.
                  </div>
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-error':
                      pipNonDigi.get('piprejInsuredMail').invalid && pipNonDigi.get('piprejInsuredMail').touched,
                  }"
                  [ngClass]="{ 'has-axis-required': pipNonDigi.get('piprejInsuredMail').value === '' }"
                >
                  <label
                    class="axis-control-label"
                    for="insuredEmail"
                    >Insured’s Email
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    autocomplete="off"
                    axis-input-clear
                    type="email"
                    class="axis-form-control"
                    id="insuredEmail"
                    formControlName="piprejInsuredMail"
                  />
                  <div
                    class="axis-error-block"
                    id="idMailError"
                    *ngIf="pipNonDigi.get('piprejInsuredMail').invalid && pipNonDigi.get('piprejInsuredMail').touched"
                  >
                    @if (pipNonDigi.get("piprejInsuredMail").hasError("pattern")) {
                      Please enter a valid Insured's Email Address.
                    } @else {
                      Please enter an Insured's Email Address.
                    }
                  </div>
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-error':
                      pipNonDigi.get('piprejInsuredAddress').value === '' &&
                      pipNonDigi.get('piprejInsuredAddress').touched,
                  }"
                  [ngClass]="{ 'has-axis-required': pipNonDigi.get('piprejInsuredAddress').value === '' }"
                >
                  <label
                    class="axis-control-label"
                    for="streetAddress"
                    >Street Address
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    [attr.aria-describedby]="
                      pipNonDigi.get('piprejInsuredAddress').value === '' ? 'streetAddressError' : null
                    "
                    type="text"
                    class="axis-form-control"
                    id="streetAddress"
                    formControlName="piprejInsuredAddress"
                  />
                  <div class="axis-help-block">This address is where the documentation for signature will be sent.</div>
                  @if (pipNonDigi.get("piprejInsuredAddress").value === "") {
                    <div
                      class="axis-error-block"
                      id="streetAddressError"
                    >
                      Please enter Street Address.
                    </div>
                  }
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-error':
                      pipNonDigi.get('piprejInsuredCity').value === '' && pipNonDigi.get('piprejInsuredCity').touched,
                  }"
                  [ngClass]="{ 'has-axis-required': pipNonDigi.get('piprejInsuredCity').value === '' }"
                >
                  <label
                    class="axis-control-label"
                    for="city"
                    >City
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    [attr.aria-describedby]="
                      pipNonDigi.get('piprejInsuredCity').value === '' ? 'businessCityError' : null
                    "
                    type="text"
                    class="axis-form-control"
                    id="city"
                    formControlName="piprejInsuredCity"
                  />
                  @if (pipNonDigi.get("piprejInsuredCity").value === "") {
                    <div
                      class="axis-error-block"
                      id="businessCityError"
                    >
                      Please enter City.
                    </div>
                  }
                </div>
              </div>
              

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group has-axis-required"
                  [ngClass]="{
                    'has-axis-error':
                      pipNonDigi.get('piprejInsuredState').value?.length < 1 &&
                      pipNonDigi.get('piprejInsuredState').touched &&
                      dropdownErrorBlurred,
                  }"
                  [ngClass]="{ 'has-axis-required': pipNonDigi.get('piprejInsuredState').value === '' }"
                >
                  <label
                    class="axis-control-label"
                    for="state"
                    >State
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <axis-dropdown
                    id="state"
                    [dataProvider]="stateList"
                    (focus)="dropdownErrorBlurred = false"
                    formControlName="piprejInsuredState"
                  ></axis-dropdown>
                  <div class="axis-error-block">Please select.</div>
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group has-axis-required"
                  [ngClass]="{
                    'has-axis-error':
                      pipNonDigi.get('piprejInsuredZipCode').invalid &&
                      pipNonDigi.get('piprejInsuredZipCode').touched,
                    'has-axis-required': pipNonDigi.get('piprejInsuredZipCode').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="zipcode"
                    >Zip Code
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                   <input
                    type="text"
                    [axisInputNumber]="mySettings110"
                    
                    class="axis-form-control"
                    id="zipcode"
                    formControlName="piprejInsuredZipCode"
                  />
                  @if (pipNonDigi.get("piprejInsuredZipCode").value === "") {
                    <div
                      class="axis-error-block"
                      id="businessZipCodeError"
                    >
                      Please enter Zip Code.
                    </div>
                  }
                  @if (pipNonDigi.get("piprejInsuredZipCode").value !== "" && 
                  pipNonDigi.get("piprejInsuredZipCode").invalid &&
                   pipNonDigi.get("piprejInsuredZipCode").hasError("pattern") &&
                  pipNonDigi.get("piprejInsuredZipCode").touched) {
                    <div
                      class="axis-error-block"
                      id="businessZipCodeError2"
                    >
                      Please enter a valid Zip Code.
                    </div>
                  }
                </div>
              </div>
            </div>
          </axis-card-body>
        </axis-card>
        <div class="axis-vertical-space _mtb-large">
          <p class="_text-bold _mtb-large">
            {{ nonDigital?.rejectionMessage }}
          </p>
          <p>{{ nonDigital?.rejectionOptMessage }}</p>
          <p class="_text-bold">
            {{ nonDigital?.backToDigitalLabel }}
            <a class="_cursor-pointer" (click)="backConsentPage()"> click here </a>.
          </p>
        </div>
      }
      @if (selectedOption === "download") {
        <axis-card id="outstandingCard">
          <axis-card-body>
            <h1 class="axis-h3">
              We have received your rejection of electronically selecting and signing your selection forms.
            </h1>
            @if (content) {
              <p
                class="_mtb-large"
                [innerHTML]="content"
              ></p>
            }
            <p class="_text-bold _mtb-large">
              If you prefer to electronically select coverage and electronically sign your selection forms, please
              <a
                routerLink="/insured/pip-consent"
                [queryParams]="{ key: requestKey }"
                >click here.</a
              >
            </p>
          </axis-card-body>
        </axis-card>
      }
    </axis-card-body>
  </axis-card>
  @if (userRole === "insured" || (userRole === "broker" && selectedOption === "digital")) {
    <div class="axis-btn-wrapper">
      <div class="axis-btn-wrapper-right">
        <button
          axis-button
          class="kind-primary"
          (click)="onContinue()"
        >
          <span class="axis-btn-icon-text">Continue</span>
        </button>
      </div>
    </div>
  }
</form>
